import * as React from "react";

import { cva } from "class-variance-authority";

import { cn } from "../../utils";

export type BadgeCitationProps = React.HTMLAttributes<HTMLSpanElement>;

const badgeCitationVariants = cva(
  "af-group af-inline-flex af-items-center af-gap-1 af-rounded-md af-border af-border-input af-bg-background/60 af-px-2 af-py-1 af-text-xs af-font-semibold af-text-accent-foreground/60 af-transition-colors hover:af-bg-accent",
);

function BadgeCitation({ className, children, ...props }: BadgeCitationProps) {
  return (
    <span className={cn(badgeCitationVariants(), className)} {...props}>
      {children}
    </span>
  );
}

function BadgeCitationKey({
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      className={cn(
        "af-rounded af-bg-input af-px-1.5 af-text-interface-foreground af-transition-colors group-hover:af-bg-interface-ring/60",
        className,
      )}
      {...props}
    />
  );
}

export { BadgeCitation, BadgeCitationKey, badgeCitationVariants };
